import {combineReducers} from 'redux';
import settings from './settings';

const reducers = {
    settings,
};

export default combineReducers(reducers);
